import { END_POINTS } from '../helpers';
import { DriveTypeData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetDriveTypeResponse = {
  count: number;
  data: DriveTypeData[];
};

export const driveTypeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDriveType: builder.query<
      CommonResponse & { data: GetDriveTypeResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getDriveSystem}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteDriveType: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteDriveSystem}/${id}`,
        method: 'DELETE',
      }),
    }),
    getDriveTypeById: builder.query<CommonResponse & { data: DriveTypeData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getDriveSystemById}/${id}`,
        method: 'GET',
      }),
    }),

    addDriveType: builder.mutation<CommonResponse & { data: DriveTypeData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addDriveSystem}`,
        method: 'POST',
        body,
      }),
    }),
    updateDriveType: builder.mutation<
      CommonResponse & { data: DriveTypeData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateDriveSystem}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddDriveTypeMutation,
  useUpdateDriveTypeMutation,
  useLazyGetDriveTypeQuery,
  useLazyDeleteDriveTypeQuery,
  useLazyGetDriveTypeByIdQuery,
} = driveTypeApi;
